<template>
    <div style="height:100%">
        <v-container fluid class="py-0" style="height:100%" color="#fff000">
            <v-row style="height:100%" class="patient-login-row" >
                <v-col cols="12" sm="12" md="4" class="white--text login-left hidden-sm-and-down">
                </v-col>
                <v-col cols="12" sm="12" md="8" align-self="center" class="inner-scroll">
                    <v-card tile flat>
                        <v-card-text>
                            <h1 class="mb-4 font-45 playfair-display black--text font-weight-medium"
                                :style="{marginTop:$vuetify.breakpoint.mdAndUp && isRegistered ? '60px' : ''}"
                            >
                                Get started with <br> <b>HealthyAlways</b>
                            </h1>
                            <template v-if="isLogin">
                                <v-row>
                                    <v-col cols="12" v-if="loginMode==='otp'">
                                        <div v-show="!isOTPSent">
                                            <h3 class="grey--text text--darken-2 font-20 mb-2 font-weight-regular">Enter your Mobile
                                                Number to get started with
                                                HealthyAlways</h3>
                                            <v-form @submit.prevent="sendOTP">
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="8" class="pb-0">
                                                        <div class="d-flex flex-row flex-nowrap">
                                                            
                                                        <v-combobox                 
                                                            
                                                            ref="code"                                                            
                                                            @blur="codeFocusOut()"
                                                            maxLength="3"
                                                            :search-input.sync="searchCode"
                                                            :items="codes"
                                                            v-model="credentials.selectedCode"                                                                                                                                                
                                                            outlined color="#013F4E"
                                                            style="max-width:108px; !important"                                                                        
                                                            label="Code"
                                                            item-text="dialCode"
                                                            item-value="dialCode"                                                    
                                                            
                                                        >                                               
                                                        </v-combobox>  
                                                        <!-- <v-text-field
                                                            outlined color="#013F4E"
                                                            label="Code"
                                                            prefix="+"                                                                                                                
                                                            style="max-width:64px"
                                                            maxlength="3"
                                                            placeholder=""
                                                            type="number"                                                        
                                                            name="Code"                                                            
                                                            v-model="credentials.selectedCode"                                                        
                                                        ></v-text-field> -->
                                                        <v-text-field label="Mobile Number"
                                                            outlined color="#013F4E"
                                                            autofocus                                                            
                                                            class="ml-3"
                                                            maxlength="10"
                                                            type="number"
                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                            v-model="credentials.mobile">

                                                        </v-text-field>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="12" class="pt-0">
                                                        <v-btn class="accent white--text" text type="submit" :loading="buttonLoader"
                                                               :disabled="buttonLoader">Send OTP
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </div>
                                        <div v-show="isOTPSent && !isOTPVerified">
                                            <h3 class="grey--text text--darken-2 font-20 mb-2 font-weight-regular">Enter OTP
                                                received on your Mobile Number</h3>
                                            <v-form @submit.prevent="verifyOTP" class="verifyOtpForm">
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="3">
                                                        <!--                                            <v-text-field autofocus ref="otp1" class="otpFields" maxlength="1"-->
                                                        <!--                                                          type="tel"-->
                                                        <!--                                                          v-model="otpPieces.otp1"-->
                                                        <!--                                                          @keypress="nextFocus('otp2')"></v-text-field>-->
                                                        <!--                                            <v-text-field ref="otp2" class="otpFields"-->
                                                        <!--                                                          type="tel"-->
                                                        <!--                                                          maxlength="1"-->
                                                        <!--                                                          v-model="otpPieces.otp2"-->
                                                        <!--                                                          @keypress="nextFocus('otp3')"></v-text-field>-->
                                                        <!--                                            <v-text-field ref="otp3" class="otpFields"-->
                                                        <!--                                                          type="tel"-->
                                                        <!--                                                          maxlength="1"-->
                                                        <!--                                                          v-model="otpPieces.otp3"-->
                                                        <!--                                                          @keypress="nextFocus('otp4')"></v-text-field>-->
                                                        <!--                                            <v-text-field ref="otp4"-->
                                                        <!--                                                          class="otpFields"-->
                                                        <!--                                                          type="tel"-->
                                                        <!--                                                          maxlength="1"-->
                                                        <!--                                                          v-model="otpPieces.otp4"></v-text-field>-->
                                                        <v-text-field type="tel" outlined color="#013F4E" maxlength="4" label="OTP"
                                                                      v-model="credentials.otp" autofocus></v-text-field>

                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="12" class="pt-0">
                                                        <v-btn class="accent white--text" text type="submit" :loading="buttonLoader"
                                                               :disabled="buttonLoader">Verify OTP
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="3">
                                                        <a href="javascript:void(0);" class="pointer" @click="isOTPSent = false">Change
                                                            Number</a>
                                                    </v-col>
                                                    <v-col sm="6" class="text-right">
                                                      <a href="javascript:void(0);" @click="sendOTP()" v-if="!timerValue">Resend OTP</a>
                                                      <template v-else>
                                                        <span>Resend OTP</span>
                                                        <br>
                                                        <span>in {{timerValue}} seconds</span>
                                                      </template>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" v-else-if="loginMode==='password'">
                                        <v-form @submit.prevent="loginEmailPassword">
                                            <h3 class="grey--text text--darken-2 font-20 mb-2 font-weight-regular">Enter your Email & Password to login</h3>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="8" class="pb-0">
                                                    <v-text-field
                                                            outlined color="#013F4E"
                                                            label="Email"
                                                            type="email"
                                                            autocomplete="new-password"
                                                            autofocus
                                                            name="Email"
                                                            v-model="credentials.email"
                                                    ></v-text-field>
                                                    <v-text-field
                                                            outlined color="#013F4E"
                                                            label="Password"
                                                            autocomplete="new-password"
                                                            name="Password"
                                                            v-model="credentials.password"
                                                            :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                            @click:append="() => (hidePassword = !hidePassword)"
                                                            :type="hidePassword ? 'password' : 'text'"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-btn class="accent white--text" :disabled="buttonLoader" color="patientButton" type="submit">
                                                Login
                                            </v-btn>
                                        </v-form>
                                    </v-col>
                                </v-row>
                                <v-row v-show="isRegistered">
                                    <v-col cols="12">
                                        <a href="#" class="black--text" @click.prevent="changeMode('password')" v-if="loginMode === 'otp'">Login via email & password instead?</a>
                                        <a href="#" class="black--text" @click.prevent="changeMode('otp')" v-if="loginMode === 'password'">Login via mobile & OTP instead?</a>
                                    </v-col>
                                    <v-col cols="12" class="body-2">
                                        Don't have a login? <a @click="showSignUp" href="javascript:void(0);">Sign Up</a>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-else>
                                <div v-show="!isOTPSent">
                                    <h3 class="grey--text text--darken-2 font-20 mb-2 font-weight-regular">Enter your Mobile
                                        Number to get started with
                                        HealthyAlways</h3>
                                    <v-form @submit.prevent="sendOTP">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="8" class="pb-0">
                                                <div class="d-flex flex-row flex-nowrap">
                                                    <v-combobox
                                                            
                                                            @blur="codeFocusOut()"
                                                            ref="code"                                                            
                                                            :items="codes"
                                                            :search-input.sync="searchCode"
                                                            maxLength="3"
                                                            v-model="credentials.selectedCode"                                                                                                                                                
                                                            outlined color="#013F4E"
                                                            style="max-width:108px; !important"                                                                        
                                                            label="Code"
                                                            item-text="dialCode"
                                                            item-value="dialCode"                                                    
                                                            autofocus
                                                        >                                               
                                                    </v-combobox>  
                                                    <!-- <v-text-field
                                                        outlined color="#013F4E"
                                                        label="Code"
                                                        prefix="+"                                                                                                                
                                                        style="max-width:64px"
                                                        maxlength="3"
                                                        placeholder=""
                                                        type="number"                                                        
                                                        name="Code"                                                        
                                                        v-model="credentials.selectedCode"                                                        
                                                    ></v-text-field> -->
                                                    <v-text-field label="Mobile Number"
                                                              outlined color="#013F4E"
                                                              class="flex-grow-1 ml-3"
                                                              autofocus
                                                              maxlength="10"
                                                              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                              type="number"
                                                              v-model="credentials.mobile">
                                                    </v-text-field>
                                                </div>
                                                
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="pt-0">
                                                <v-btn class="accent white--text" text type="submit" :loading="buttonLoader"
                                                       :disabled="buttonLoader">Send OTP
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </div>
                                <div v-show="isOTPSent && !isOTPVerified">
                                    <h3 class="grey--text text--darken-2 font-20 mb-2 font-weight-regular">Enter OTP
                                        received on your Mobile Number</h3>
                                    <v-form @submit.prevent="verifyOTP" class="verifyOtpForm">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="3">
                                                <!--                                            <v-text-field autofocus ref="otp1" class="otpFields" maxlength="1"-->
                                                <!--                                                          type="tel"-->
                                                <!--                                                          v-model="otpPieces.otp1"-->
                                                <!--                                                          @keypress="nextFocus('otp2')"></v-text-field>-->
                                                <!--                                            <v-text-field ref="otp2" class="otpFields"-->
                                                <!--                                                          type="tel"-->
                                                <!--                                                          maxlength="1"-->
                                                <!--                                                          v-model="otpPieces.otp2"-->
                                                <!--                                                          @keypress="nextFocus('otp3')"></v-text-field>-->
                                                <!--                                            <v-text-field ref="otp3" class="otpFields"-->
                                                <!--                                                          type="tel"-->
                                                <!--                                                          maxlength="1"-->
                                                <!--                                                          v-model="otpPieces.otp3"-->
                                                <!--                                                          @keypress="nextFocus('otp4')"></v-text-field>-->
                                                <!--                                            <v-text-field ref="otp4"-->
                                                <!--                                                          class="otpFields"-->
                                                <!--                                                          type="tel"-->
                                                <!--                                                          maxlength="1"-->
                                                <!--                                                          v-model="otpPieces.otp4"></v-text-field>-->
                                                <v-text-field type="tel" outlined color="#013F4E" maxlength="4" label="OTP"
                                                              v-model="credentials.otp" autofocus></v-text-field>

                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="pt-0">
                                                <v-btn class="accent white--text" text type="submit" :loading="buttonLoader"
                                                       :disabled="buttonLoader">Verify OTP
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="3">
                                                <a href="javascript:void(0);" class="pointer" @click="isOTPSent = false">Change
                                                    Number</a>
                                            </v-col>
                                            <v-col sm="6" class="text-right">
                                                <a href="javascript:void(0);" @click="sendOTP()" v-if="!timerValue">Resend OTP</a>
                                                <template v-else>
                                                <span>Resend OTP</span>
                                                <br>
                                                <span>in {{timerValue}} seconds</span>
                                                </template>
                                            </v-col>
                                            <!-- <v-col cols="12" sm="12" md="3">
                                                <a href="javascript:void(0);" @click="sendOTP">Resend OTP</a>
                                            </v-col> -->
                                        </v-row>
                                    </v-form>
                                </div>
                                
                                <v-row>
                                    <v-col cols="12" class="body-2" v-if="isRegistered && (!isOTPSent || !isOTPVerified)">
                                        Already registered? <a @click="showLogin" href="javascript:void(0);">Login Here...</a>
                                    </v-col>
                                </v-row>
                            </template>
                            <div v-show="!isRegistered" class="mt-5">
                                <h3 class="grey--text text--darken-2 font-20 mb-2 font-weight-regular">Enter your
                                    details</h3>
                                <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
                                <v-form @submit.prevent="showVerifyEmailDialog">
                                    <v-row>
                                        <v-col cols="12" sm="12" md="8">                                            
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="6">        
                                                    <ValidationProvider name="First Name" rules="required" v-slot="{ errors }">
                                                        <v-text-field 
                                                            label="First Name*" 
                                                            outlined 
                                                            color="#013F4E" 
                                                            autofocus
                                                            :dense="isDialogLogin"
                                                            hide-details="auto"
                                                            v-model="patient.first_name"
                                                            :error-messages="errors"
                                                        >
                                                        </v-text-field>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <ValidationProvider name="Last Name" rules="required" v-slot="{ errors }">
                                                        <v-text-field 
                                                            label="Last Name*" 
                                                            outlined 
                                                            color="#013F4E" 
                                                            autofocus
                                                            :dense="isDialogLogin"
                                                            hide-details="auto"
                                                            v-model="patient.last_name"
                                                            :error-messages="errors"
                                                        >
                                                        </v-text-field>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="mt-3">
                                                    <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
                                                        <v-text-field
                                                            hide-details="auto"
                                                            :dense="isDialogLogin"
                                                            autocomplete="new-password" 
                                                            label="Email*" 
                                                            type="email" 
                                                            outlined 
                                                            color="#013F4E"
                                                            v-model="patient.email"
                                                            :error-messages="errors"
                                                        >
                                                        </v-text-field>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="mt-3">
                                                    <ValidationProvider name="Password" rules="min:8" v-slot="{ errors }">
                                                        <v-text-field
                                                            :dense="isDialogLogin"
                                                            hide-details="auto"
                                                            autocomplete="new-password" 
                                                            label="Password*" 
                                                            v-model="patient.password"
                                                            outlined 
                                                            color="#013F4E" 
                                                            type="password"
                                                            :error-messages="errors"
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" class="mt-3">
                                                    <v-menu
                                                            ref="menu"
                                                            v-model="menu"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="290px"
                                                            :close-on-content-click="false"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                            hide-details="auto"
                                                                    v-model="patient.dob"
                                                                    label="Date of Birth*"
                                                                    :dense="isDialogLogin"
                                                                    readonly
                                                                    v-on="on"
                                                                    outlined color="#013F4E"
                                                            ></v-text-field>
                                                        </template>
                                                        
                                                        <v-date-picker
                                                                ref="picker"
                                                                v-model="patient.dob"
                                                                :max="moment().subtract('years',minAge).toISOString().substr(0, 10)"                                                                
                                                                min="1900-01-01"
                                                                @change="$refs.menu.save(patient.dob)"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn text color="primary" @click="menu = false">Cancel
                                                            </v-btn>
                                                            <v-btn text color="primary" @click="$refs.menu.save(date)">
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                
                                                <v-col cols="12" sm="12" md="6" class="mt-3">
                                                    <v-select
                                                    hide-details="auto"
                                                    :dense="isDialogLogin"
                                                     label="Gender*" outlined color="#013F4E"
                                                              v-model="patient.gender" :items="genderList"></v-select>
                                                </v-col>
                                                <v-col class="mt-3">
                                                    <city-autocomplete
                                                        ref="city_autocomplete"
                                                        v-on:placechanged="getCity"                                    
                                                        :dense="isDialogLogin"
                                                        :place_types="'(cities)'"
                                                        :place_filter="[]"
                                                    ></city-autocomplete>
                                                </v-col>         
                                                <v-col cols="12" sm="12" md="12">
                                                    By clicking Register you are agreeing to our
                                                    <a href="javascript:void(0)" @click="tAndCModal = true">Terms and
                                                        Conditions. </a>
                                                </v-col>
                                                                                       
                                                <v-col cols="12" sm="12" md="12" class="pt-0">
                                                    <br>
                                                    <v-btn class="accent white--text" text type="submit"
                                                           :loading="buttonLoader" :disabled="buttonLoader || invalid" >Register
                                                    </v-btn>
                                                </v-col>
                                                
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                </ValidationObserver>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="12" md="8">
                                    <v-alert type="error" v-if="formErrors.length">
                                        <ul>
                                            <li v-for="error in formErrors" :key="error">
                                                {{ error }}
                                            </li>
                                        </ul>
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!--        Login Modal-->
        <v-dialog v-model="tAndCModal" max-width="900">
            <v-card>
                <v-card-text>
                    <terms-and-conditions></terms-and-conditions>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="tAndCModal = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="emailOtpObj.showDialog"
                scrollable
                :overlay="false"
                max-width="500px"
                transition="dialog-transition"            
            >
            <v-card class="">
                <v-card-title class="">Email Verification Code</v-card-title>
                <v-card-text>
                    
                    <ValidationObserver ref="verifyOtp" v-slot="{ invalid, handleSubmit }">
                            <v-form v-show="emailOtpObj.otpSent" @submit.prevent="handleSubmit(registerPatient)">
                                <v-row>
                                    <v-col cols="12" sm="12" md="8" class="mt-1 mb-0 pb-0">
                                        <ValidationProvider name="Code" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                outlined
                                                label="Code"
                                                type="text"
                                                dense
                                                autofocus
                                                v-model="emailOtpObj.otp"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" mb-0 pb-0>
                                        <v-btn rounded :disabled="emailOtpObj.otpSubmitLoader" color="accent" class="white--text no-uppercase"  type="submit">
                                            Verify
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="9" class="mt-0 pt-0">                                                                                                                       
                                        <v-row style="font-size: 13px" class="mt-0 pt-0">
                                            <v-col sm="6" class="text-left">
                                                <a class="darkPrimary--text" href="#" @click="emailOtpObj.showDialog = false">Cancel</a>
                                                                                            
                                            </v-col>
                                            <v-col sm="6" class="text-right">
                                                <a href="#" class="darkPrimary--text" @click="sendEmailOtp()">Resend Code</a>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </ValidationObserver>
                </v-card-text>
                
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import TermsAndConditions from "./TermsAndConditions";
    import * as countryCodeUtil from '../../data.js'
    import CityAutocomplete from '../CityAutocomplete.vue';

    export default {
        name: "PatientLogin",
        components: {
            TermsAndConditions,
            CityAutocomplete
        },
        props: ['loginRedirect','isDialog'],
        data() {
            return {
                hidePassword: true,
                timerInterval: null,
                timerValue: 30,
                searchCode:"",
                isLogin: true,
                loginMode: 'otp',
                buttonLoader: false,
                menu: false,
                tAndCModal: false,
                formErrors: [],
                credentials: {
                    mobile: '',
                    otp: '',
                    email: '',
                    password: '',
                    selectedCode:''
                },
                otpPieces: {
                    otp1: null,
                    otp2: null,
                    otp3: null,
                    otp4: null,
                },
                isOTPSent: false,
                isOTPVerified: false,
                userType: 'PATIENT',
                isRegistered: true,
                authenticationInfo: {},
                genderList: ['Male', 'Female'],
                patient: {
                    first_name:null,
                    last_name:null,
                    city:null,
                    name: null,
                    gender: null,
                    dob: null,
                    is_primary_profile: 1,
                    mobile: null,
                    email: null,

                },
                minAge:18,
                currentPhoneCode:'',
                codes:[],
                isDialogLogin:true,
                emailOtpObj:{                                        
                    otpSent:true,
                    otp:"",
                    showDialog:false,
                    otpSubmitLoader:false,
                    sendOtpApiSuccess:false
                },
            };
        },
        methods: {
            codeFocusOut(){
                
                if(!this.searchCode)
                    return;
                var country_data = countryCodeUtil.getNearestCode(this.searchCode)                
                if(country_data){
                    this.credentials.selectedCode = country_data.dialCode
                    this.currentPhoneCode = country_data.dialCode
                }                                                        
                    
            },
            getCity(place) {                
                this.patient.city = place.name                
            },
            redirectUser(accessToken,patient_id){
                var current_url = new URL(window.location.href)
                const currentUrlParams = new URLSearchParams(current_url.search); 
                var redirectToParam = currentUrlParams.get('redirect');                
                
                var newURL = new URL(`${process.env.VUE_APP_PATIENT_URL}/patients-authentication?accessToken=` + accessToken + `&userId=` + patient_id + `&userType=PATIENT`)                
                if(redirectToParam != null && redirectToParam.length >0)
                    newURL.searchParams.set('redirect', redirectToParam);                            

                window.location.href = newURL.href
                
            },
            showLogin(){
                this.isLogin = true;
                this.isOTPSent = false;
                this.loginMode = 'otp'
            },
            showSignUp(){
                this.isLogin = false;
                this.isOTPSent = false;
                this.loginMode = 'otp'
            },
            loginEmailPassword() {
                this.buttonLoader = true;
                this.clearErrors();
                let emailLoginRequest = {
                    user_type: this.userType,
                    email: this.credentials.email,
                    password: this.credentials.password,
                    type: 'login',
                    mode: 'PASSWORD'                    
                }
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/login`, emailLoginRequest)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.isOTPVerified = true;
                            let loginObject = {
                                accessToken: response.data.access_token,
                                userId: response.data.user_id,
                                userType: this.userType,
                                userInfo: response.data.patient,
                                mobile: response.data.patient.mobile,
                                timezone:response.data.timezone
                            }
                            this.authenticationInfo = loginObject;
                            this.$store.dispatch('userLogin', loginObject);
                            this.$store.dispatch('storeUserInfo', response.data.patient);
                            this.dateutils.setTimezone(loginObject.timezone)
                            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
                            if (loginObject.userInfo) {
                                this.$emit('loginResult');
                                // if (this.loginRedirect) {
                                //     this.$router.push({name: this.loginRedirect});
                                // }                                                                
                            if (this.loginRedirect === 'home') 
                                this.redirectUser(loginObject.accessToken, response.data.patient.id)                                                                
                            } else {
                                this.isRegistered = false;
                            }
                        } else {
                            this.formErrors.push(response.data.message);
                        }
                    }).catch((error) => {
                    this.formErrors.push(error.response.data.message);
                    console.log(error);
                }).finally((response) => {
                    this.buttonLoader = false;
                    console.log(response); // response object undefined
                });
            },
            changeMode(loginMode) {
                this.credentials = {
                    mobile: '',                    
                    otp: '',
                    email: '',
                    password: '',
                    selectedCode: this.currentPhoneCode
                }
                this.clearErrors();
                this.loginMode = loginMode
            },
            clearErrors() {
                this.formErrors = [];
            },
            sendOTP() {
                this.buttonLoader = true;
                this.clearErrors();
                
                let sendOTPRequest = {
                    mobile: this.credentials.mobile,
                    code: this.credentials.selectedCode
                }
                console.log(sendOTPRequest)
                this.axios
                    .post(`${process.env.VUE_APP_API_URL}/api/authentication/send-otp`, sendOTPRequest)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.isOTPSent = true;
                            this.timerValue = 30
                            clearInterval(this.timerInterval)
                            this.timerInterval = setInterval(() => {
                                --this.timerValue
                              if(this.timerValue == 0) {
                                clearInterval(this.timerInterval)
                              }
                            }, 1000)
                        } else {
                            this.formErrors[0] = response.data.message;
                        }

                    }).catch((error) => {
                    console.log(error);                                                            
                    var ctx = this
                    var err_values = this.getErrorsArray(error.response.data.errors)
                    err_values.forEach(function(entry) {
                        ctx.formErrors.push(entry);
                    });   
                }).finally((response) => {
                    this.buttonLoader = false;
                    console.log(response); // response object undefined
                });
            },
            verifyOTP() {
                this.buttonLoader = true;
                this.clearErrors();
                // this.credentials.otp = Object.values(this.otpPieces).join('');
                let verifyOTPRequest = {
                    user_type: this.userType,
                    otp: this.credentials.otp,
                    mobile: this.credentials.mobile,
                    type: this.isLogin ? 'login' : 'register',
                    mode: 'OTP',
                    timezone:this.$store.getters.timezone,
                    code:this.credentials.selectedCode
                }
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/login`, verifyOTPRequest)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.isOTPVerified = true;
                            let loginObject = {
                                accessToken: response.data.access_token,
                                userId: response.data.user_id,
                                userType: this.userType,
                                userInfo: response.data.patient,
                                mobile: this.credentials.mobile,
                                timezone:response.data.timezone
                            }
                            this.authenticationInfo = loginObject;
                            this.$store.dispatch('userLogin', loginObject);
                            this.$store.dispatch('storeUserInfo', response.data.patient);
                            this.dateutils.setTimezone(loginObject.timezone)
                            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
                            if (loginObject.userInfo) {
                                this.$emit('loginResult');
                                // if (this.loginRedirect) {
                                //     this.$router.push({name: this.loginRedirect});
                                // }
                                this.$emit('loginResult');
                                if (this.loginRedirect === 'home') 
                                    this.redirectUser( loginObject.accessToken,response.data.patient.id)                                    
                            } else {
                                this.isRegistered = false;
                            }
                        } else {
                            this.formErrors.push(response.data.message);
                        }
                    }).catch((error) => {
                    this.formErrors.push(error.response.data.message);
                    console.log(error);
                }).finally((response) => {
                    this.buttonLoader = false;
                    console.log(response); // response object undefined
                });
            },
            registerPatient() {
                this.buttonLoader = true;
                this.patient.mobile = this.credentials.mobile;
                this.patient.timezone = this.dateutils.moment.tz.guess(true);
                this.patient.email_verification_code = this.emailOtpObj.otp
                                
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/update-profile`, this.patient)
                    .then((response) => {
                        if(response.data && response.data.status === 1){
                            this.$store.dispatch('storeUserInfo', response.data.data);
                            this.$emit('loginResult');
                            if (this.loginRedirect === 'home') {
                                this.redirectUser( this.authenticationInfo.accessToken,response.data.data.id)                                
                            }

                            
                        }
                        else if(response.data.status == 0){
                            this.$store.commit('showSnackbar', {message:response.data.message})
                        }
                        
                    }).catch((error) => {
                    
                    var errs = error.response.data.errors
                    var ctx = this        
                    var err_values = Object.values(errs)
                    ctx.formErrors = []
                    err_values.forEach(function(entry) {
                        entry.forEach(function(val) {
                            ctx.formErrors.push(val);
                        });                        
                    });                    
                    
                }).finally((response) => {
                    this.buttonLoader = false;
                    console.log(response); // response object undefined
                });
            },
            nextFocus(number) {
                this.$refs[number].focus()
            },           
            getCountryCode() {                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/ipdata`)
                    .then((response) => {
                        var cc = response.data.country_code
                        var country_data = countryCodeUtil.getByCountryCode(cc)
                        
                        if(country_data){
                            this.credentials.selectedCode = country_data.dialCode
                            this.currentPhoneCode = country_data.dialCode
                        }
                            
                            
                        
                    }).catch((error)=>{
                    console.log(error);
                }).finally(() => {
                    this.submitLoader = false
                })
            },
            showVerifyEmailDialog(){
                this.sendEmailOtp().then(()=>{
                    if(this.emailOtpObj.sendOtpApiSuccess)
                        this.emailOtpObj.showDialog = true
                })
                
            },
            sendEmailOtp() {
                let sendOTPRequest = {
                    email: this.patient.email                    
                }
                this.emailOtpObj.otpSubmitLoader = true
                this.emailOtpObj.sendOtpApiSuccess = false
                return new Promise((resolve) => {
                    this.axios.post(`${process.env.VUE_APP_API_URL}/api/authentication/v2/send-verification-mail`, sendOTPRequest)
                    .then((response) => {
                        if(response.data.status == 1){
                            this.emailOtpObj.sendOtpApiSuccess = true
                            this.$store.commit('showSnackbar', {message:response.data.message})
                            this.emailOtpObj.otpSent = true;                                                                                    
                        }
                        
                    }).catch((error)=>{
                        console.log(error);
                    }).finally(() => {
                        this.emailOtpObj.otpSubmitLoader = false                        
                        resolve()
                    })
                })
                
            },
            
        },
        watch: {            
            loginMode(){
                this.credentials.selectedCode = this.currentPhoneCode
            },
            menu (val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },
        mounted(){
            
            if(this.isDialog != null)
                this.isDialogLogin = this.isDialog
            else
                this.isDialogLogin = true


            this.codes = countryCodeUtil.countryCodes
            this.getCountryCode()
        }
    }
</script>


<style scoped>
    .verifyOtpForm input {
        font-size: 30px;
        text-align: center !important;
    }

    .otpFields {
        display: inline-block;
        width: 35px;
        margin: 8px;
        font-size: 30px;
        text-align: center !important;
    }

   .inner-scroll{
       overflow-y: scroll;
       height: 80vh;
   }
   
</style>